import { useEffect, useState } from "react"

const usePageVisibilityChange = () => {
    const [isPageVisiblityChanged, setIsPageVisiblityChanged] = useState(false)

    const visibilityChangeHandler = () => {
        if (document.visibilityState !== "hidden") {
            setIsPageVisiblityChanged(true)

            setTimeout(()=> {setIsPageVisiblityChanged(false)}, 1)
        }
    }

    useEffect(()=> {
        document.addEventListener("visibilitychange", visibilityChangeHandler);

        return () => {
            document.removeEventListener("visibilitychange", visibilityChangeHandler);
        }
    },[])
    return {isPageVisiblityChanged}
}

export default usePageVisibilityChange